import { translate } from '../../../common/translations';
import config from 'app/config';


const DeliveryDetailsAddress = ({ lang, boxes, delivery, styles }) => {
	return (
		<div className="row division pt-0 pb-0 mt-0">
			<div className="col-12 address">
				<div>
					<h3 className="subheading" style={styles.textHighlight}>{translate(lang, 'Address')}</h3>
					{delivery.city} {delivery.state} {delivery.postcode}<br />
				</div>

				<div>
					<h3 className="subheading" style={styles.textHighlight}>{translate(lang, 'Carrier')}</h3>
					<div>{delivery.service}</div>
				</div>
			</div>

			<div className="col-12">
				<h3 className="subheading mt-3" style={styles.textHighlight}>{translate(lang, 'Boxes')}</h3>

				{boxes && boxes !== undefined && boxes.map((box, index) =>
					<p key={index}>(# {index + 1}) {' '} {box.barcode}</p>
				)}
			</div>
		</div>
	);
}

export default DeliveryDetailsAddress;